const countDecimals = (value: number) => value.toString().split(".")[1]?.length ?? 0;

const parseSliderInput = (input: string): number | undefined => {
  const normalized = input.trim().replace(",", ".");
  if (normalized === "") return undefined;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : undefined;
};

const snapToStep = (value: number, min: number, max: number, step: number) => {
  if (value <= min) return min;
  if (value >= max) return max;
  const decimals = Math.max(countDecimals(step), countDecimals(min));
  const stepsFromMin = Number(((value - min) / step).toFixed(10));
  const snapped = Number((min + Math.round(stepsFromMin) * step).toFixed(decimals));
  return Math.min(max, snapped);
};

const snapToClosestMark = (value: number, marks: number[], min: number, max: number) => {
  const closestMark = marks.reduce((closest, mark) =>
    Math.abs(mark - value) < Math.abs(closest - value) ? mark : closest,
  );
  return Math.min(max, Math.max(min, closestMark));
};

export { parseSliderInput, snapToClosestMark, snapToStep };
